<template>
  <div>
    <el-form ref="searchConditions" :model="form" :rules="rules" label-width="100px" label-position="left" @submit.native.prevent>
      <el-row>
        <el-col :span="10">
          <el-form-item label="手机号码：" prop="searchPhone">
            <el-input placeholder="请输入手机号码" @change="onSearchPhoneChange" @keyup.enter.native="searchStudentMemberInfoByPhone(false)" v-model="form.searchPhone" class="input-width cs-advanceEnrollment-phone">
              <el-button slot="append" size="small" :type="submitBtnClass" :disabled="submitBtnDisable" @click="searchStudentMemberInfoByPhone(false)">确认</el-button>
              <el-button class="cs-btnRefundInfo" slot="append" size="small" :type="submitBtnClass" :disabled="submitBtnDisable" @click="searchStudentMemberInfoByPhone(true)">查看上次退课订单</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-show="displayMemberInfo" v-loading="loading">
      <member-info ref="member-info" :data-in="memberInfoData" :options="memberInfoOptions" @register="onRegister" @buyMemberCard="onBuyMemberCard"></member-info>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.stepContent {
  padding: 20px;
}

.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
  }
}
.cs-advanceEnrollment-phone {
  min-width: 360px;

  .cs-btnRefundInfo{
    margin-left: 25px;
  }
}
</style>

<script>
import {
  createStudentMemberInfoModel,
  getStudentMemberInfo
} from "../../../service/student.service";
import memberInfo from "../../common/memberInfo_new";

export default {
  props: {
    dataIn: {
      hasBuyMemberCard:Boolean
    }
  },
  data() {
    let validatePhone = (rule, value, callback) => {
      if (!!value){
        value = value.trim();
      }
      let message = "";
      let pattern = /^\d{10,11}$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的手机号码";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      hasBuyMemberCard:false,
      memberInfoData:{},
      memberInfoOptions:{},
      loading: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      displayMemberInfo:false,
      form:{
        searchPhone:""
      },
      rules: {
        searchPhone: [
           {
            required: true,
            message: "手机号码不能为空",
            trigger: ["blur", "change"]
          },
          {
          validator: validatePhone,
          trigger: "blur"
        }]
      }
    };
  },
  components: {
    memberInfo
  },
  computed: {},
  created() {
    this.memberInfoOptions = {
      showTitle: false,
      showPhone: true,
      enableEdit: false,
      enableBuymember : true,
      showIsNew: true,
      enableRegister: true
    };
  },
  updated() {
    this.checkSearchConditions();
  },
  methods: {
    onSearchPhoneChange(){
      if (!!this.form.searchPhone){
        this.form.searchPhone = this.form.searchPhone.trim();
      }
    },
    onRegister(){
      this.searchStudentMemberInfoByPhone(false);
    },
    onBuyMemberCard(data){
      this.hasBuyMemberCard = data.isBuy;
      this.$emit("buyMemberCard", data);
    },
    checkSearchConditions() {
      let isValid = true;

      let $ref = this.$refs["searchConditions"];
      if (!!$ref) {
        $ref.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }
      return isValid;
    },
    async searchStudentMemberInfoByPhone(isRefund) {
      if (!this.checkSearchConditions()) {
        return;
      }

      this.submitBtnDisable = true;
      this.loading = true;
      await this.loadMemberInfo(true);

      this.$emit("reload", this.memberInfoData, 0, isRefund);

      this.displayMemberInfo = true;
      this.loading = false;
      this.submitBtnDisable = false;
    },
    async searchStudentMemberInfoById(studentId, workflowId, initType) {
      this.submitBtnDisable = true;
      this.loading = true;
      await this.loadMemberInfo(true, studentId, workflowId);
      
      this.$emit("reload", this.memberInfoData, workflowId, initType, false);

      this.displayMemberInfo = true;
      this.loading = false;
      this.submitBtnDisable = false;
    },
    async loadMemberInfo(isReload, studentId){
      if (typeof studentId == "undefined"){
        studentId = null;
      }
    
      let memberModel = null;
      try {
        let result = await getStudentMemberInfo(studentId, this.form.searchPhone);
        if (result && result.success) {
          memberModel = result.data;
          if (!!studentId){
            this.form.searchPhone = memberModel.Phone;
          }
        }
      } catch (error) {
      }
      if (!memberModel){
        memberModel = {Phone:this.form.searchPhone};
      }
      if (!!this.memberInfoData){
        if (isReload){
          this.memberInfoData = {memberModel: memberModel, hasBuyMemberCard: false};
        }else{
          this.memberInfoData =  {memberModel: memberModel, hasBuyMemberCard: this.memberInfoData.hasBuyMemberCard};
        } 
      }else{
         this.memberInfoData = {memberModel: memberModel, hasBuyMemberCard: false};
      }
      return memberModel;
    }
  },
  watch: {
    dataIn:function(){
      if (!!this.dataIn){    
        this.hasBuyMemberCard = this.dataIn.hasBuyMemberCard;
        this.$set(this.memberInfoData, "hasBuyMemberCard", this.hasBuyMemberCard);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/workflowStep1.vue